import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Spinner,
  Button
} from 'reactstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
  faExclamationTriangle,
  faCheckCircle,
  faCircleInfo,
  faCancel,
  faTrash,
  faQuestionCircle,
  faListAlt,
  faClock
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import Heading from '../common/Heading';
import Comments from '../bugscrub/Comments';
import CommentModal from '../bugscrub/CommentModal';
import DeleteProjectModal from '../bugscrub/DeleteProjectModal';
import ODD from '../../constants/odd';
import BZAPIService from '../../services/BZAPIService';
import { set } from 'lodash';
const BugScrubbingTool = () => {
  // State for form controls and accordion
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [savingProject, setSavingProject] = useState(false);
  const [savingBugCve, setSavingBugCve] = useState(false);
  const [savingVersionState, setSavingVersionState] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [step, setStep] = useState(1);
  const [projectName, setProjectName] = useState('');
  const [showBugComment, setShowBugComment] = useState(null);
  const [showCveComment, setShowCveComment] = useState(null);
  const [showDeleteProject, setShowDeleteProject] = useState(null);
  const [creatingProject, setCreatingProject] = useState(false);
  const [bugStates, setBugStates] = useState({});
  const [cveStates, setCveStates] = useState({});
  // const [versionStatus, setVersionStatus] = useState('Not reviewed');
  const [userVersionData, setUserVersionData] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [vendor, setVendor] = useState(null);
  const [loadingAccordion, setLoadingAccordion] = useState(true);
  const [showDefects, setShowDefects] = useState(false);
  const [showCVEs, setShowCVEs] = useState(false);
  const [bugs, setBugs] = useState([]);
  const [cves, setCves] = useState([]);
  const [bugAverage, setBugAverage] = useState(null);
  const [cveAverage, setCveAverage] = useState(null);
  const [product, setProduct] = useState(null);
  const [version, setVersion] = useState(null);
  const [products, setProducts] = useState([]); // For products fetched dynamically
  const [versions, setVersions] = useState([]); // For versions fetched dynamically
  const [upgradeVersions, setUpgradeVersions] = useState([]); // For versions fetched dynamically
  const [openAccordion, setOpenAccordion] = useState(''); // for managing accordion state
  const [loadingProject, setLoadingProject] = useState(false); // Track loading for products
  const [loadingVendors, setLoadingVendors] = useState(true); // Track loading for products
  const [loadingProducts, setLoadingProducts] = useState(false); // Track loading for products
  const [loadingVersions, setLoadingVersions] = useState(false); // Track loading for versions
  const [loadingUpgradeVersions, setLoadingUpgradeVersions] = useState(false); // Track loading for versions
  const [bugFilters, setBugFilters] = useState({}); // Track loading for versions
  const [cveFilters, setCveFilters] = useState({}); // Track loading for versions
  const [bugFilterMeta, setBugFilterMeta] = useState([]); // Track loading for versions
  const [cveFilterMeta, setCveFilterMeta] = useState([]); // Track loading for versions

  const filterByValueOption = (option, inputValue) => {
    // Search only in the `value` field
    return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
  };
  const handleProjectSelection = async project => {
    setLoadingProject(true);
    // get project detail
    const projectDetail = await BZAPIService.bsaGetProject(project.id);
    setSelectedProject(projectDetail);
    console.log('selectedProject', project);
    console.log('vendors', vendors);
    const selectedVendor = vendors.find(vendor => vendor.value === project.vendorId);
    console.log('selectedVendor', selectedVendor);
    setVendor(selectedVendor);
    const products = await fetchProducts(selectedVendor); // Fetch products for the selected vendor
    console.log('products', products);
    const selectedProduct = products.find(product => product.value === project.productId);
    setProduct(selectedProduct);
    console.log('selectedProduct', selectedProduct);
    const versions = await fetchVersions(selectedProduct, selectedVendor); // Fetch versions for the selected product
    console.log('versions x', versions);
    const selectedVersion = versions.find(version => version.value === project.versionId);
    console.log('selectedVersion', selectedVersion);
    setVersion(selectedVersion);
    await fetchUpgradeVersions(selectedVersion, selectedVendor, selectedProduct); // Fetch versions for the selected product
    setProjectName(project.name);
    setStep(2);
    setLoadingProject(false);
  };
  const reviewStateOptions = [
    { value: 'Not reviewed', label: 'Not reviewed' },
    { value: 'In review', label: 'In review' },
    { value: 'Declined', label: 'Declined' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Uncertain', label: 'Uncertain' }
  ];
  // const bsaCreateVersionComment = async project => {
  // BZAPIService.bsaCreateVersionComment()
  // }

  // BZAPIService.bsaDeleteVersionComment()
  // BZAPIService.bsaDeleteBugOrCveComment()
  // BZAPIService.bsaCreateBugOrCveComment()
  // BZAPIService.bsaCreateProject()
  // BZAPIService.bsaSetVersionState()
  // BZAPIService.bsaListProjects()
  // BZAPIService.bsaGetProject()
  // BZAPIService.bsaListProjectVersions()

  const handleDeleteBugOrCveComment = async project => {
    await BZAPIService.bsaDeleteBugOrCveComment();
  };

  const handleDeleteVersionComment = async project => {
    await BZAPIService.bsaDeleteVersionComment();
  };
  const handleSetVersionState = async data => {
    console.log('handleSetVersionState', data, selectedProject.versions, data.versionId);
    await BZAPIService.bsaSetVersionState(data);
    const projectDetail = await BZAPIService.bsaGetProject(selectedProject.id);
    setSelectedProject(projectDetail);

    // update local state optimistically

    setUserVersionData({ ...userVersionData, state: data.state });
  };
  const handleCreateBugOrCveComment = async project => {
    await BZAPIService.bsaCreateBugOrCveComment();
  };
  const handleGetProject = async project => {
    await BZAPIService.bsaGetProject();
  };
  const handleListProjectVersions = async project => {
    const response = await BZAPIService.bsaListProjectVersions();
    console.log('project versions', response);
    // set state
  };
  const resetSelectedVersion = () => {
    setSelectedVersion(null);
    setBugAverage(null);
    setCveAverage(null);
    setBugs([]);
    setCves([]);
    setUserVersionData(null);
    setBugStates({});
    setCveStates({});
  };
  const handleStartCreateProject = async project => {
    setCreatingProject(true);
    setVendor(null);
    setProduct(null);
    setVersion(null);
    setStep(2);
  };
  const handleCreateProject = async () => {
    setSavingProject(true);
    const project = {
      vendorId: vendor.value,
      versionId: version.value,
      name: projectName,
      productName: product.label,
      productId: product.value
    };

    const createdProject = await BZAPIService.bsaCreateProject(project);
    setSavingProject(false);
    setProjects([...projects, createdProject]);
    handleProjectSelection(createdProject);
    setCreatingProject(false);
  };

  // Options for selects

  const customStyles = {
    // This will target the remove (X) icon in multi-selects
    multiValueRemove: (provided, state) => ({
      ...provided,
      color: 'white', // Change the icon color to white
      // Optionally, modify the hover state:
      ':hover': {
        backgroundColor: '#253746', // Change this to your desired hover background color
        color: 'white' // Ensure the icon remains white on hover
      }
    })
  };

  // API Call to Fetch Projects
  const fetchProjects = async () => {
    try {
      const response = await BZAPIService.bsaListProjects();
      console.log('projects', response);
      setProjects(response);
      setLoadingProjects(false);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    }
  };
  // API Call to Fetch Products
  const fetchVendors = async () => {
    try {
      // Simulated API Call
      const response = await fetch(`${ODD.api}settings?bstSupport=1`);
      const data = await response.json();
      console.log('vendors', data);
      // Example response: [{ value: 'nexus-9000', label: 'Nexus 9000 Switch' }]
      if (data?.length) {
        const vendorOptions = data.map(vendor => ({
          value: vendor.vendorId,
          label: vendor.label
        }));
        console.log('vendorOptions', vendorOptions);
        setVendors(vendorOptions);
      }
      setLoadingVendors(false); // End loading
    } catch (error) {
      console.error('Failed to fetch vendors:', error);
      setLoadingVendors(false); // End loading
    }
  };
  // API Call to Fetch Products
  const fetchProducts = async selectedVendor => {
    setLoadingProducts(true); // Start loading
    setProduct(null);
    setVersion(null);
    setVersions([]);
    try {
      // Simulated API Call
      const response = await fetch(`${ODD.api}bst/getBstVendorProducts?vendor_id=${selectedVendor.value}`);
      const data = await response.json();
      console.log('products res', data);
      // Example response: [{ value: 'nexus-9000', label: 'Nexus 9000 Switch' }]
      if (data?.results) {
        const productOptions = data.results.map(product => ({
          value: product.productId,
          label: product.productName
        }));
        console.log('productOptions', productOptions);
        setProducts(productOptions);
        setLoadingProducts(false); // End loading

        return productOptions;
      }
      setLoadingProducts(false); // End loading
    } catch (error) {
      console.error('Failed to fetch products:', error);
      setLoadingProducts(false); // End loading
    }
  };

  // API Call to Fetch Versions
  const fetchVersions = async (selectedProduct, vendor) => {
    setVersion(null);
    try {
      // Simulated API Call
      const response = await fetch(
        `${ODD.api}bst/getBstSoftwareSuggestions?vendor_id=${vendor.value}&product_id=${selectedProduct.value}`
      );
      const data = await response.json();
      console.log('versions', data);
      if (data?.results) {
        const versionOptions = data.results.map(product => ({
          value: product.suggestionId,
          labelBug: product.labelBug,
          labelCve: product.labelCve,
          label: product.releaseVersion
        }));
        setVersions(versionOptions);
        setLoadingVersions(false);

        return versionOptions;
      }
      setLoadingVersions(false);
      // Example response: [{ value: '15.0', label: '15.0(1k)' }]
    } catch (error) {
      console.error('Failed to fetch versions:', error);
      setLoadingVersions(false);
    }
  };
  const fetchCves = async selectedVersion => {
    try {
      // Simulated API Call
      const response = await fetch(
        `${ODD.api}bst/getBstCves?vendor_id=${vendor.value}&software_type=${selectedVersion.softwareType}&version=${
          selectedVersion.labelCve
        }`
      );
      const data = await response.json();
      console.log('fetchCves', data);
      if (data?.results) {
        setCveAverage(data?.cvssAverage);
        console.log('cveAverage', data?.cvssAverage);
        setCves(data.results);
      }
      // Example response: [{ value: '15.0', label: '15.0(1k)' }]
    } catch (error) {
      console.error('Failed to fetch versions:', error);
    }
  };
  const fetchBugs = async selectedVersion => {
    try {
      // Simulated API Call
      // ${ODD.api}bst/getBstBugs?product_name=PAN-OS&version=11.1.2&vendor_id=paloalto
      const response = await fetch(
        `${ODD.api}bst/getBstBugs?vendor_id=${vendor.value}&product_name=${product.label}&version=${
          selectedVersion.labelBug
        }`
      );
      const data = await response.json();
      console.log('fetchBugs', data);
      if (data?.results) {
        setBugAverage(data?.riskScoreAverage);

        setBugs(data.results);
      }
      // Example response: [{ value: '15.0', label: '15.0(1k)' }]
    } catch (error) {
      console.error('Failed to fetch versions:', error);
    }
  };
  const fetchUserVersionState = async selectedVersion => {
    console.log('fetchUserVersionStatex', selectedVersion);
    // to get version state we must find it in the selected project

    try {
      const userVersionState = selectedProject.versions.find(
        version => version.versionId === selectedVersion.suggestionId
      );
      console.log('userVersionState', userVersionState);
      if (userVersionState) {
        console.log('found fetchUserVersionState', userVersionState);
        const response = await BZAPIService.bsaListProjectVersions(userVersionState.id);
        console.log('BZAPIService.bsaListProjectVersions', response);
        setUserVersionData({ ...response });
        // Iterate the bugs and set the state for each bug
        const bugStates = {};
        response.bugs.forEach(bug => {
          console.log('bug', bug);
          bugStates[bug.bugId] = { value: bug.state, edit: false };
        });
        console.log('bugStates', bugStates);
        setBugStates(bugStates);
        // Iterate the cves and set the state for each cve
        const cveStates = {};
        response.cves.forEach(cve => {
          cveStates[cve.cveId] = { value: cve.state, edit: false };
        });
        setCveStates(cveStates);

        /*
        {
          "id": "6a5d5a9d-50dd-4c3c-bdd8-9064ea370bc4",
          "versionId": "Everest-16.6.2",
          "updatedAt": "2025-02-22 23:15:23",
          "createdAt": "2025-02-22 23:15:23",
          "productName": "1100 Integrated Services Router",
          "productId": "286315006",
          "state": "Declined",
          "comments": [],
          "activityLog": [
              {
                  "field": "",
                  "value": "",
                  "change": "Created project version",
                  "userId": "dev-chase@findbugzero.com",
                  "timestamp": "2025-02-22T23:15:22.813405"
              },
              {
                  "field": "state",
                  "value": "Declined",
                  "change": "State set to Declined",
                  "userId": "dev-chase@findbugzero.com",
                  "timestamp": "2025-02-22T23:15:22.813417"
              }
          ],
          "bugs": [],
          "cves": []
      }
          */
      } else {
        // If version does not exist, create it by setting the state to "Not reviewed"
        console.log('create version');
        const response = await BZAPIService.bsaSetVersionState({
          versionId: selectedVersion.suggestionId,
          projectId: selectedProject.id,
          productName: selectedProject.productName,
          productId: selectedProject.productId,
          state: 'Not reviewed'
        });
        // Set userVersionData
        console.log('BZAPIService.bsaSetVersionState create', response);

        // Refetch the project to get the new version
        const projectDetail = await BZAPIService.bsaGetProject(selectedProject.id);
        console.log('projectDetail', projectDetail);
        setSelectedProject(projectDetail);
        const responseProjectVersion = await BZAPIService.bsaListProjectVersions(response.projectVersionId);
        console.log('BZAPIService.bsaListProjectVersions', responseProjectVersion);
        setUserVersionData({ ...responseProjectVersion });
      }

      // Example response: [{ value: '15.0', label: '15.0(1k)' }]
    } catch (error) {
      console.error('Failed to fetch versions:', error);
      setUserVersionData(null);
    }
  };

  // API Call to Fetch Versions
  const fetchUpgradeVersions = async (selectedVersion, vendor, product) => {
    console.log(selectedVersion, 'selectedVersion');
    // setVersion(null);
    console.log(vendor.value, 'vendor.value');
    console.log(product.value, 'product.value');
    console.log(selectedVersion.value, 'selectedVersion.value');
    try {
      // Simulated API Call
      const response = await fetch(
        `${ODD.api}bst/getBstSoftwareSuggestions?vendor_id=${vendor.value}&product_id=${
          product.value
        }&current_version=${selectedVersion.value}`
      );
      const data = await response.json();
      console.log('versions', data);
      if (data?.results) {
        console.log('upgradeVersions', data.results);
        setUpgradeVersions(data.results);
        setBugFilterMeta(data?.metadata?.filters?.bug);
        setCveFilterMeta(data?.metadata?.filters?.cve);
        console.log('cveFilterMeta', data?.metadata?.filters?.cve);
        console.log('versionFilterMeta', data?.metadata?.filters?.version);
      }
      setLoadingUpgradeVersions(false);
      // Example response: [{ value: '15.0', label: '15.0(1k)' }]
    } catch (error) {
      console.error('Failed to fetch upgrade versions:', error);
      setLoadingUpgradeVersions(false);
    }
  };

  // Toggle accordion for each version selectVersion
  const toggleAccordion = async id => {
    console.log('toggleAccordion', id);
    console.log('upgradeVersion expanded', upgradeVersions[id]);
    const selectedVersion = upgradeVersions[id];
    // fetch bugs and cves
    setLoadingAccordion(true);
    const openAccordionId = openAccordion === id ? '' : id;
    setOpenAccordion(openAccordionId);
    // Reset selected Version data
    resetSelectedVersion();
    if (openAccordionId) {
      await Promise.all(
        [fetchCves(selectedVersion), fetchBugs(selectedVersion)],
        fetchUserVersionState(selectedVersion)
      );
      setSelectedVersion(selectedVersion);
      setBugFilters({});
      setCveFilters({});

      setShowCVEs(true);
      setShowDefects(true);
    }
    setLoadingAccordion(false);
  };

  // Function to determine color and label based on risk score
  const getRiskDetails = score => {
    if (score >= 8) return { color: 'red', label: 'High' };
    if (score >= 5) return { color: 'orange', label: 'Medium' };
    if (score > 0) return { color: 'green', label: 'Low' };
    return { color: 'grey', label: 'Not available' };
  };
  const getStateIcons = state => {
    let className, icon;
    if (state === 'Not reviewed') {
      className = 'text-muted';
      icon = faCircleInfo;
    }
    if (state === 'In review') {
      className = 'text-primary';
      icon = faClock;
    }
    if (state === 'Declined') {
      className = 'text-danger';
      icon = faCancel;
    }
    if (state === 'Accepted') {
      className = 'text-success';
      icon = faCheckCircle;
    }
    if (state === 'Uncertain') {
      className = 'text-dark';
      icon = faQuestionCircle;
    }
    className += ' me-2';
    return <FontAwesomeIcon icon={icon} className={className} />;
  };

  const getStateColors = state => {
    let className;
    if (state === 'Not reviewed') className = 'text-muted';
    if (state === 'In review') className = 'text-primary';
    if (state === 'Declined') className = 'text-danger';
    if (state === 'Accepted') className = 'text-success';
    if (state === 'Uncertain') className = 'text-dark';
    className += ' pr-4';
    return (
      <span className={className} style={{ fontWeight: 'bold' }}>
        {state}
      </span>
    );
  };

  const getUniqueCveOptions = key => {
    const uniqueValues = Array.from(new Set(cves.map(item => item[key]).filter(value => value !== undefined)));
    return uniqueValues.map(value => ({
      value,
      label: value
    }));
  };

  const getFilteredCves = () => {
    if (!cveFilters || Object.keys(cveFilters).length === 0) {
      return cves; // No filters applied
    }

    return cves.filter(cve => {
      // Check if each CVE matches at least one value for all selected filter keys
      return Object.entries(cveFilters).every(([key, selectedValues]) => {
        if (selectedValues.length === 0) return true; // Skip if no values are selected for this key
        return selectedValues.includes(cve[key]); // Match any selected value for this key
      });
    });
  };

  const getUniqueBugOptions = key => {
    const uniqueValues = Array.from(new Set(bugs.map(item => item[key]).filter(value => value !== undefined)));
    return uniqueValues.map(value => ({
      value,
      label: value
    }));
  };

  const getFilteredBugs = () => {
    if (!bugFilters || Object.keys(bugFilters).length === 0) {
      return bugs; // No filters applied
    }

    return bugs.filter(bug => {
      // Check if each bug matches at least one value for all selected filter keys
      return Object.entries(bugFilters).every(([key, selectedValues]) => {
        if (selectedValues.length === 0) return true; // Skip if no values are selected for this key
        return selectedValues.includes(bug[key]); // Match any selected value for this key
      });
    });
  };

  // Set a variable with getFilteredBugs() and getFilteredCves() to get the average bugRiskScore and cvssAverage
  useEffect(() => {
    const filteredBugs = getFilteredBugs();
    const filteredCves = getFilteredCves();

    const calculateAverage = (items, key) => {
      if (items.length === 0) return null;
      let validItems = items.filter(item => item[key] !== undefined && item[key] !== null && item[key] !== '');
      // Filter further if state is Ignored, Not applicable
      console.log('valid items', validItems);
      console.log('userVersionData', userVersionData);
      if (key === 'bugRiskScore') {
        // filter validItems further if an item inside it is inside userVersionData.bugs matches the id and the state is Ignored or Not applicable
        validItems = validItems.filter(item => {
          const bugState = userVersionData?.bugs.find(bug => bug.bugId === item.id)?.state;
          return bugState !== 'Ignored' && bugState !== 'Not applicable';
        });
        console.log('valid items 2', validItems);
      }

      if (key === 'cvss_base_score') {
        validItems = validItems.filter(item => {
          const cveState = userVersionData?.cves.find(cve => cve.cveId === item.id)?.state;
          return cveState !== 'Ignored' && cveState !== 'Not applicable';
        });
      }

      if (validItems.length === 0) return null;
      const sum = validItems.reduce((acc, item) => acc + Number(item[key]), 0);
      return (sum / validItems.length).toFixed(2);
    };
    console.log('useEffect', calculateAverage(filteredBugs, 'bugRiskScore'));

    setBugAverage(calculateAverage(filteredBugs, 'bugRiskScore'));
    setCveAverage(calculateAverage(filteredCves, 'cvss_base_score'));
  }, [bugFilters, cveFilters, bugs, cves, userVersionData]);

  useEffect(() => {
    fetchVendors();
    fetchProjects();
  }, []);
  // Check if all selections are made for Step 1
  const isStep1Complete = vendor && product && version;

  if (savingProject) {
    return (
      <div className="text-center my-8">
        <Spinner color="primary" />
        <p>Creating your project...</p>
      </div>
    );
  }

  if (loadingProjects) {
    return (
      <div className="text-center my-8">
        <Spinner color="primary" />
        <p>Loading projects...</p>
      </div>
    );
  }
  return (
    <Container className="mt-4">
      {/* Header */}
      <Heading
        title={'Bug Scrub Advisor'}
        subtitle={`Compare product versions by reviewing security and operational risks`}
        className="mb-4 mt-3"
        icon="bug"
        loading={false}
      />
      {loadingProject && (
        <div className="text-center my-8">
          <Spinner color="primary" />
          <p>Loading project data...</p>
        </div>
      )}

      {step === 1 && !loadingProject && (
        <Card className="mb-4">
          <CardBody>
            <h5>Select or Create a Project</h5>
            <ul className="mt-4 list-group">
              {projects.map(proj => (
                <li key={proj.id} className="list-group-item d-flex justify-content-between align-items-center">
                  <Button color="link" onClick={() => handleProjectSelection(proj)}>
                    {proj.name}
                  </Button>
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="text-danger"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setShowDeleteProject(proj);
                    }}
                  />
                </li>
              ))}
            </ul>
            <div className="text-right">
              <Button className="mt-4 btn btn-falcon-default btn-sm" onClick={handleStartCreateProject}>
                Create New Project
              </Button>
            </div>
          </CardBody>
        </Card>
      )}

      {/* Step 1: Vendor, Product, Version Selection */}
      {step === 2 && !loadingProject && (
        <>
          <div className="text-right">
            <Button
              className="mb-3 btn btn-falcon-default btn-sm"
              onClick={() => {
                setStep(1);
                setCreatingProject(false);
              }}
            >
              Exit project
            </Button>
          </div>
          <Card className="mb-4">
            <CardBody>
              <h5>Select your current vendor, product, and version</h5>
              <Row className="mt-4">
                <Col md="3">
                  <label>Vendor *</label>
                  <Select
                    options={loadingVendors ? [] : vendors}
                    value={vendor}
                    isDisabled={loadingVendors || (isStep1Complete && !creatingProject && step !== 1)} // Disable if no vendor or loading
                    placeholder={loadingVendors ? 'Loading vendors...' : 'Select a vendor'}
                    components={{
                      LoadingIndicator: () => (loadingVendors ? <Spinner size="sm" color="primary" /> : null)
                    }}
                    onChange={selectedVendor => {
                      setLoadingProducts(true);
                      setVendor(selectedVendor);
                      fetchProducts(selectedVendor); // Fetch products for the selected vendor
                    }}
                  />
                </Col>
                <Col md="6">
                  <label>Product *</label>
                  <Select
                    options={loadingProducts ? [] : products}
                    value={product}
                    isDisabled={!vendor || loadingProducts || (isStep1Complete && !creatingProject && step !== 1)} // Disable if no vendor or loading
                    onChange={selectedProduct => {
                      setLoadingVersions(true); // Start loading
                      setProduct(selectedProduct);
                      fetchVersions(selectedProduct, vendor); // Fetch versions for the selected product
                    }}
                    filterOption={filterByValueOption} // Apply custom filtering
                    placeholder={loadingProducts ? 'Loading products...' : 'Select a product'}
                    components={{
                      LoadingIndicator: () => (loadingProducts ? <Spinner size="sm" color="primary" /> : null)
                    }}
                  />
                </Col>
                <Col md="3">
                  <label>Current version *</label>
                  <Select
                    options={loadingVersions ? [] : versions}
                    value={version}
                    isDisabled={!product || loadingVersions || (isStep1Complete && !creatingProject && step !== 1)} // Disable if no product or loading
                    onChange={selectedVersion => {
                      setLoadingUpgradeVersions(true); // Start loading
                      setOpenAccordion(''); // reset accordion
                      setVersion(selectedVersion);
                      setProjectName(`${vendor.label} - ${product.label} - ${selectedVersion.label}`);
                      fetchUpgradeVersions(selectedVersion, vendor, product); // Fetch versions for the selected product
                    }}
                    placeholder={loadingVersions ? 'Loading versions...' : 'Select a version'}
                    components={{
                      LoadingIndicator: () => (loadingVersions ? <Spinner size="sm" color="primary" /> : null)
                    }}
                  />
                </Col>
                {/* <Col md="2">
              <label>Upgrade or downgrade?</label>
              <Select options={upgradeOptions} value={upgradeOption} onChange={setUpgradeOption} />
            </Col> */}
              </Row>
              {version && (
                <Row className="mt-4">
                  <Col md="12">
                    <label>Project Name *</label>
                    <input
                      type="text"
                      disabled={isStep1Complete && !creatingProject && step !== 1}
                      className="form-control"
                      value={projectName}
                      onChange={e => setProjectName(e.target.value)}
                      placeholder="Enter project name"
                      maxLength={128}
                    />
                  </Col>
                  {creatingProject && (
                    <Col md="12" className="text-end mt-3">
                      <Button
                        className="btn btn-falcon-default btn-sm"
                        onClick={handleCreateProject}
                        disabled={!projectName}
                      >
                        Create Project
                      </Button>
                    </Col>
                  )}
                </Row>
              )}
            </CardBody>
          </Card>
        </>
      )}

      {/* Step 2: Version X-Ray - only show if Step 1 is complete */}
      {isStep1Complete && !creatingProject && step !== 1 && !loadingProject && (
        <Card className="mb-4">
          <CardBody>
            <Row className="align-items-center mb-3">
              <Col md="6">
                <h5>Available versions</h5>

                {/* <label>How can your next version be? *</label>
                <Select options={nextVersionOptions} value={nextVersion} onChange={setNextVersion} /> */}
              </Col>
              <Col md="6" className="text-end">
                <div>
                  <label className="text-bold">{product.label}</label>
                </div>
                <label>Current Version: {version.label}</label>
              </Col>
            </Row>
            {loadingUpgradeVersions && (
              <div className="text-center my-8">
                <Spinner color="primary" />
                <p>Loading version data...</p>
              </div>
            )}

            {upgradeVersions.length === 0 && !loadingUpgradeVersions && (
              <div className="text-center my-8">
                <p>No compatible versions found.</p>
              </div>
            )}
            {/* Available Versions List as Accordion */}
            {!!upgradeVersions.length && !loadingUpgradeVersions && (
              <>
                <Accordion open={openAccordion} toggle={toggleAccordion} flush>
                  {/* First Accordion Item */}
                  {/* todo: filter versions based on filters to only return results that match the selected filters */}
                  {upgradeVersions.map((upgradeVersion, index) => (
                    <AccordionItem key={index}>
                      <AccordionHeader targetId={`${index}`} className="bg-transparent">
                        <div className="d-flex justify-content-between w-100">
                          <span>
                            {getStateIcons(
                              selectedProject?.versions.find(
                                version => version.versionId === upgradeVersion.suggestionId
                              )?.state || 'Not reviewed'
                            )}
                            {upgradeVersion.releaseVersion}{' '}
                            {upgradeVersion?.releaseDate
                              ? ` (${moment.utc(upgradeVersion.releaseDate).format('YYYY-MM-DD')})`
                              : ' '}
                          </span>
                          {getStateColors(
                            selectedProject?.versions.find(version => version.versionId === upgradeVersion.suggestionId)
                              ?.state || 'Not reviewed'
                          )}
                          {upgradeVersion?.isSuggested && (
                            <div>
                              <span className="mr-4" style={{ color: 'green', fontWeight: 'bold' }}>
                                <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                                Suggested upgrade
                              </span>
                            </div>
                          )}
                        </div>
                      </AccordionHeader>
                      <AccordionBody accordionId={`${index}`}>
                        {/* Version and Version Age */}
                        {loadingAccordion ? (
                          <div className="text-center my-10">
                            <Spinner color="primary" />
                            <p>Loading version data...</p>
                          </div>
                        ) : (
                          <>
                            {upgradeVersion.suggestionId === selectedVersion?.suggestionId && (
                              <>
                                <Row className="mb-4">
                                  <Col md="6" className="text-start">
                                    <h4 className="fw-bold mb-0">Version: {upgradeVersion.releaseVersion}</h4>
                                  </Col>
                                  <Col md="6" className="text-end">
                                    <FontAwesomeIcon icon={faClock} className="me-1" />
                                    <span>
                                      Version Age:{' '}
                                      {upgradeVersion?.releaseDate
                                        ? moment.utc(upgradeVersion?.releaseDate).fromNow()
                                        : '-'}
                                    </span>
                                  </Col>
                                </Row>
                                <div className="p-4 rounded mb-4 text-center">
                                  <Row className="justify-content-center mb-4 mt-4">
                                    {/* Operational Risk Section */}
                                    <Col md="3" className="text-center">
                                      <FontAwesomeIcon
                                        icon={faExclamationTriangle}
                                        style={{ color: getRiskDetails(bugAverage).color }}
                                        className="mb-2"
                                        size="2x"
                                      />
                                      <div>Operational Risk</div>
                                      <div className="display-6" style={{ color: getRiskDetails(bugAverage).color }}>
                                        {bugAverage || '-'}
                                      </div>
                                      <div style={{ color: getRiskDetails(bugAverage).color, fontSize: '0.85rem' }}>
                                        {getRiskDetails(bugAverage).label}
                                      </div>
                                    </Col>
                                    {/* Security Risk Section */}
                                    <Col md="3" className="text-center">
                                      <FontAwesomeIcon
                                        icon={faShieldAlt}
                                        style={{ color: getRiskDetails(cveAverage).color }}
                                        className="mb-2"
                                        size="2x"
                                      />
                                      <div>Security Risk</div>
                                      <div className="display-6" style={{ color: getRiskDetails(cveAverage).color }}>
                                        {cveAverage || '-'}
                                      </div>
                                      <div style={{ color: getRiskDetails(cveAverage).color, fontSize: '0.85rem' }}>
                                        {getRiskDetails(cveAverage).label}
                                      </div>
                                    </Col>
                                    {/* Total Operational Defects Section */}
                                    <Col md="3" className="text-center">
                                      <FontAwesomeIcon
                                        icon={faListAlt}
                                        className="mb-2"
                                        size="2x"
                                        style={{ color: '#000' }}
                                      />
                                      <div>Total Operational Bugs</div>
                                      <div className="display-6" style={{ color: '#000' }}>
                                        {bugs.length}
                                      </div>
                                    </Col>
                                    <Col md="3" className="text-center">
                                      <FontAwesomeIcon
                                        icon={faListAlt}
                                        className="mb-2"
                                        size="2x"
                                        style={{ color: '#000' }}
                                      />
                                      <div>Total CVEs</div>
                                      <div className="display-6" style={{ color: '#000' }}>
                                        {cves.length}
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                                <Row className="mt-3">
                                  <Col md="6">
                                    <h6 className="my-4" style={{ fontSize: '1.25rem', cursor: 'pointer' }}>
                                      <FontAwesomeIcon icon={faListAlt} className="me-2" />
                                      Review state
                                    </h6>

                                    <Select
                                      options={reviewStateOptions}
                                      value={
                                        userVersionData?.state
                                          ? { value: userVersionData?.state, label: userVersionData?.state }
                                          : reviewStateOptions[0]
                                      }
                                      onChange={async e => {
                                        setSavingVersionState(true);
                                        await handleSetVersionState({
                                          state: e.value,
                                          versionId: upgradeVersion.suggestionId,
                                          projectId: selectedProject.id,
                                          productName: selectedProject.productName,
                                          productId: selectedProject.productId
                                        });
                                        setSavingVersionState(false);
                                      }}
                                      isDisabled={savingVersionState}
                                    />
                                    {savingVersionState && (
                                      <div className="text-center mt-2">
                                        <Spinner size="sm" color="primary" />
                                        <p>Saving...</p>
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                                <Comments
                                  comments={userVersionData?.comments || []}
                                  setUserVersionData={setUserVersionData}
                                  userVersionData={userVersionData}
                                  fetchUserVersionState={fetchUserVersionState}
                                  selectedVersion={selectedVersion}
                                  projectId={selectedProject.id}
                                  versionId={upgradeVersion.suggestionId}
                                  productName={selectedProject.productName}
                                  productId={selectedProject.productId}
                                />{' '}
                                {/* Defects Table */}
                                <h6
                                  className="mt-4"
                                  style={{ fontSize: '1.25rem', cursor: 'pointer' }}
                                  onClick={() => setShowDefects(!showDefects)}
                                >
                                  <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                  {getFilteredBugs()?.length || 0} Operational Bugs ({' '}
                                  <a style={{ textDecoration: 'underline' }}>{showDefects ? 'Hide' : 'Show'}</a> )
                                </h6>
                                {!!bugFilterMeta?.length && showDefects && (
                                  <>
                                    <Row className="my-4">
                                      {bugFilterMeta.map((filter, index) => (
                                        <Col key={index} md="3">
                                          <label>Filter {filter.label}</label>
                                          <Select
                                            isMulti // Enables multi-select
                                            styles={customStyles}
                                            theme={theme => ({
                                              ...theme,
                                              borderRadius: 0,
                                              colors: {
                                                ...theme.colors,
                                                // text: 'white',
                                                // primary25: '#253746',
                                                primary: '#253746',
                                                neutral80: 'white',
                                                neutral10: '#253746',
                                                dangerLight: '#bf6e4c'
                                              }
                                            })}
                                            options={getUniqueBugOptions(filter.key)} // Dynamically generate unique options for this filter
                                            value={(bugFilters[filter.key] || []).map(value => ({
                                              value,
                                              label: value
                                            }))} // Convert the array of values into select-compatible objects
                                            onChange={selected => {
                                              setBugFilters({
                                                ...bugFilters,
                                                [filter.key]: selected ? selected.map(item => item.value) : [] // Update selected values for this filter key
                                              });
                                            }}
                                          />
                                        </Col>
                                      ))}
                                    </Row>
                                  </>
                                )}
                                {showDefects && (
                                  <Table bordered hover className="bst-data mt-2">
                                    <thead>
                                      <tr>
                                        <th>Bug ID</th>
                                        <th>Summary</th>
                                        <th>Severity</th>
                                        <th>BugZero Risk Score</th>
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {bugs.length > 0 ? (
                                        getFilteredBugs().map((bug, index) => (
                                          <tr id={index} key={index}>
                                            <td>
                                              <a href={bug?.vendor_url} target="_blank" rel="noopener noreferrer">
                                                <span
                                                  className={
                                                    bugStates[bug.id]?.value === 'Not applicable' ||
                                                    bugStates[bug.id]?.value === 'Ignored'
                                                      ? 'text-decoration-line-through'
                                                      : ''
                                                  }
                                                >
                                                  {bug.id}
                                                </span>
                                              </a>
                                            </td>
                                            <td>
                                              <span
                                                className={
                                                  bugStates[bug.id]?.value === 'Not applicable' ||
                                                  bugStates[bug.id]?.value === 'Ignored'
                                                    ? 'text-decoration-line-through'
                                                    : ''
                                                }
                                              >
                                                {bug?.title || '-'}
                                              </span>
                                            </td>
                                            <td>
                                              {' '}
                                              <span
                                                className={
                                                  bugStates[bug.id]?.value === 'Not applicable' ||
                                                  bugStates[bug.id]?.value === 'Ignored'
                                                    ? 'text-decoration-line-through'
                                                    : ''
                                                }
                                              >
                                                {bug?.severity || '-'}
                                              </span>
                                            </td>
                                            <td>
                                              {bug?.bugRiskScore ? (
                                                <a
                                                  href={`${bug.oddUrl}/operational-defect-database/vendors/${
                                                    bug.vendor_id
                                                  }/defects/${bug.id}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <span
                                                    className={
                                                      bugStates[bug.id]?.value === 'Not applicable' ||
                                                      bugStates[bug.id]?.value === 'Ignored'
                                                        ? 'text-decoration-line-through'
                                                        : ''
                                                    }
                                                  >
                                                    {bug?.bugRiskScore}
                                                  </span>
                                                </a>
                                              ) : (
                                                '-'
                                              )}
                                            </td>
                                            <td>
                                              <button
                                                className="text-muted"
                                                onClick={e => {
                                                  e.preventDefault();
                                                  console.log('showBugComment', bug.id);
                                                  setShowBugComment(bug.id);
                                                }}
                                                style={{
                                                  fontSize: '0.85rem',
                                                  background: 'none',
                                                  border: 'none',
                                                  padding: 0,
                                                  cursor: 'pointer',
                                                  textDecoration: 'underline',
                                                  whiteSpace: 'nowrap'
                                                }}
                                              >
                                                {userVersionData?.bugs?.find(item => item.bugId === bug.id)?.comments
                                                  ?.length || 'No'}{' '}
                                                {userVersionData?.bugs?.find(item => item.bugId === bug.id)?.comments
                                                  ?.length === 1
                                                  ? 'comment'
                                                  : 'comments'}
                                              </button>
                                              <br />
                                              {bugStates[bug.id]?.edit ? (
                                                <>
                                                  <Select
                                                    styles={{
                                                      control: provided => ({
                                                        ...provided,
                                                        width: 'auto', // Adjust width dynamically
                                                        minWidth: 'fit-content', // Prevent ellipsis
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '100%' // Avoid excessive growth
                                                      }),
                                                      menu: provided => ({
                                                        ...provided,
                                                        whiteSpace: 'nowrap',

                                                        width: 'auto' // Ensure dropdown matches content width
                                                      })
                                                    }}
                                                    isDisabled={savingBugCve}
                                                    // className="w-auto"
                                                    options={[
                                                      { value: 'Not reviewed', label: 'Not reviewed' },
                                                      { value: 'Ignored', label: 'Ignored' },
                                                      { value: 'Confirmed', label: 'Confirmed' },
                                                      { value: 'Uncertain', label: 'Uncertain' },
                                                      { value: 'Not applicable', label: 'Not applicable' }
                                                    ]}
                                                    value={{
                                                      value: bugStates[bug.id]?.value,
                                                      label: bugStates[bug.id]?.value
                                                    }}
                                                    onChange={async e => {
                                                      // setVersionStatus(e.value);
                                                      // Save the new state
                                                      setSavingBugCve(true);
                                                      await BZAPIService.bsaSetVersionBugCveState({
                                                        projectVersionId: userVersionData.id,
                                                        productName: selectedProject.productName,
                                                        productId: selectedProject.productId,
                                                        vendorId: selectedProject.vendorId,
                                                        isCve: false,
                                                        bugId: bug.id,
                                                        state: e.value
                                                      });
                                                      await fetchUserVersionState(selectedVersion);

                                                      // setBugStates({
                                                      //   ...bugStates,
                                                      //   [bug.id]: { value: e.value, edit: false }
                                                      // });
                                                      setSavingBugCve(false);
                                                    }}
                                                  />
                                                  {savingBugCve && (
                                                    <div className="my-2 text-center">
                                                      <Spinner color="primary" />
                                                    </div>
                                                  )}
                                                </>
                                              ) : (
                                                <button
                                                  className="text-muted"
                                                  onClick={e => {
                                                    e.preventDefault();
                                                    setBugStates({
                                                      ...bugStates,
                                                      [bug.id]: {
                                                        value: bugStates[bug.id]?.value
                                                          ? bugStates[bug.id]?.value
                                                          : 'Not reviewed',
                                                        edit: true
                                                      }
                                                    });
                                                  }}
                                                  style={{
                                                    fontSize: '0.85rem',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline',
                                                    whiteSpace: 'nowrap'
                                                  }}
                                                >
                                                  {bugStates[bug.id]?.value || 'Not reviewed'}
                                                </button>
                                              )}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="5" className="text-center">
                                            No Defects found.
                                          </td>
                                        </tr>
                                      )}
                                      {/* Additional rows as needed */}
                                    </tbody>
                                  </Table>
                                )}
                                {/* CVEs Table */}
                                <h6
                                  className="mt-4"
                                  style={{ fontSize: '1.25rem', cursor: 'pointer' }}
                                  onClick={() => setShowCVEs(!showCVEs)}
                                >
                                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
                                  {getFilteredCves()?.length || 0} CVEs ({' '}
                                  <a style={{ textDecoration: 'underline' }}>{showCVEs ? 'Hide' : 'Show'}</a> )
                                </h6>
                                {!!cveFilterMeta?.length && showCVEs && (
                                  <>
                                    <Row className="my-4">
                                      {cveFilterMeta.map((filter, index) => (
                                        <Col key={index} md="3">
                                          <label>Filter {filter.label}</label>
                                          <Select
                                            isMulti // Enables multi-select
                                            styles={customStyles}
                                            theme={theme => ({
                                              ...theme,
                                              borderRadius: 0,
                                              colors: {
                                                ...theme.colors,
                                                // text: 'white',
                                                // primary25: '#253746',
                                                primary: '#253746',
                                                neutral80: 'white',
                                                neutral10: '#253746',
                                                dangerLight: '#bf6e4c'
                                              }
                                            })}
                                            options={getUniqueCveOptions(filter.key)} // Dynamically generate unique options for this filter
                                            value={(cveFilters[filter.key] || []).map(value => ({
                                              value,
                                              label: value
                                            }))} // Convert the array of values into select-compatible objects
                                            onChange={selected => {
                                              setCveFilters({
                                                ...cveFilters,
                                                [filter.key]: selected ? selected.map(item => item.value) : [] // Update selected values for this filter key
                                              });
                                            }}
                                          />
                                        </Col>
                                      ))}
                                    </Row>
                                  </>
                                )}
                                {showCVEs && (
                                  <Table bordered hover className="bst-data mt-2">
                                    <thead>
                                      <tr>
                                        <th>CVE</th>
                                        <th>Summary</th>
                                        <th>Severity</th>
                                        <th>CVSS Score</th>
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {cves.length > 0 ? (
                                        getFilteredCves().map((cve, index) => (
                                          <tr key={index}>
                                            <td>
                                              <span
                                                className={
                                                  cveStates[cve.id]?.value === 'Not applicable' ||
                                                  cveStates[cve.id]?.value === 'Ignored'
                                                    ? 'text-decoration-line-through'
                                                    : ''
                                                }
                                              >
                                                <a
                                                  href={`https://nvd.nist.gov/vuln/detail/${cve?.id}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  {cve?.id || '-'}
                                                </a>
                                              </span>
                                            </td>
                                            <td>
                                              {' '}
                                              <span
                                                className={
                                                  cveStates[cve.id]?.value === 'Not applicable' ||
                                                  cveStates[cve.id]?.value === 'Ignored'
                                                    ? 'text-decoration-line-through'
                                                    : ''
                                                }
                                              >
                                                {cve?.title || '-'}
                                              </span>
                                            </td>
                                            <td>
                                              {' '}
                                              <span
                                                className={
                                                  cveStates[cve.id]?.value === 'Not applicable' ||
                                                  cveStates[cve.id]?.value === 'Ignored'
                                                    ? 'text-decoration-line-through'
                                                    : ''
                                                }
                                              >
                                                {cve?.severity || '-'}
                                              </span>
                                            </td>
                                            <td>
                                              {' '}
                                              <span
                                                className={
                                                  cveStates[cve.id]?.value === 'Not applicable' ||
                                                  cveStates[cve.id]?.value === 'Ignored'
                                                    ? 'text-decoration-line-through'
                                                    : ''
                                                }
                                              >
                                                {cve?.cvss_base_score || '-'}
                                              </span>
                                            </td>
                                            <td>
                                              <td>
                                                <button
                                                  className="text-muted"
                                                  onClick={e => {
                                                    e.preventDefault();
                                                    console.log('showCveComment', cve.id);
                                                    setShowCveComment(cve.id);
                                                  }}
                                                  style={{
                                                    fontSize: '0.85rem',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline',
                                                    whiteSpace: 'nowrap'
                                                  }}
                                                >
                                                  {userVersionData?.cves?.find(item => item.cveId === cve.id)?.comments
                                                    ?.length || 'No'}{' '}
                                                  {userVersionData?.cves?.find(item => item.cveId === cve.id)?.comments
                                                    ?.length === 1
                                                    ? 'comment'
                                                    : 'comments'}
                                                </button>
                                                <br />
                                                {cveStates[cve.id]?.edit ? (
                                                  <>
                                                    <Select
                                                      styles={{
                                                        control: provided => ({
                                                          ...provided,
                                                          width: 'auto', // Adjust width dynamically
                                                          minWidth: 'fit-content', // Prevent ellipsis
                                                          whiteSpace: 'nowrap',
                                                          maxWidth: '100%' // Avoid excessive growth
                                                        }),
                                                        menu: provided => ({
                                                          ...provided,
                                                          whiteSpace: 'nowrap',

                                                          width: 'auto' // Ensure dropdown matches content width
                                                        })
                                                      }}
                                                      isDisabled={savingBugCve}
                                                      // className="w-auto"
                                                      options={[
                                                        { value: 'Not reviewed', label: 'Not reviewed' },
                                                        { value: 'Ignored', label: 'Ignored' },
                                                        { value: 'Confirmed', label: 'Confirmed' },
                                                        { value: 'Uncertain', label: 'Uncertain' },
                                                        { value: 'Not applicable', label: 'Not applicable' }
                                                      ]}
                                                      value={{
                                                        value: cveStates[cve.id]?.value,
                                                        label: cveStates[cve.id]?.value
                                                      }}
                                                      onChange={async e => {
                                                        // setVersionStatus(e.value);
                                                        // Save the new state
                                                        setSavingBugCve(true);
                                                        await BZAPIService.bsaSetVersionBugCveState({
                                                          projectVersionId: userVersionData.id,
                                                          productName: selectedProject.productName,
                                                          productId: selectedProject.productId,
                                                          vendorId: selectedProject.vendorId,
                                                          isCve: true,
                                                          cveId: cve.id,
                                                          state: e.value
                                                        });
                                                        await fetchUserVersionState(selectedVersion);

                                                        // setBugStates({
                                                        //   ...cveStates,
                                                        //   [cve.id]: { value: e.value, edit: false }
                                                        // });
                                                        setSavingBugCve(false);
                                                      }}
                                                    />
                                                    {savingBugCve && (
                                                      <div className="my-2 text-center">
                                                        <Spinner color="primary" />
                                                      </div>
                                                    )}
                                                  </>
                                                ) : (
                                                  <button
                                                    className="text-muted"
                                                    onClick={e => {
                                                      e.preventDefault();
                                                      setCveStates({
                                                        ...cveStates,
                                                        [cve.id]: {
                                                          value: cveStates[cve.id]?.value
                                                            ? cveStates[cve.id]?.value
                                                            : 'Not reviewed',
                                                          edit: true
                                                        }
                                                      });
                                                    }}
                                                    style={{
                                                      fontSize: '0.85rem',
                                                      background: 'none',
                                                      border: 'none',
                                                      padding: 0,
                                                      cursor: 'pointer',
                                                      textDecoration: 'underline',
                                                      whiteSpace: 'nowrap'
                                                    }}
                                                  >
                                                    {cveStates[cve.id]?.value || 'Not reviewed'}
                                                  </button>
                                                )}
                                              </td>
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="5" className="text-center">
                                            No CVEs found.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </AccordionBody>
                    </AccordionItem>
                  ))}
                </Accordion>
              </>
            )}
          </CardBody>
        </Card>
      )}
      {showBugComment && (
        <CommentModal
          isOpen={!!showBugComment}
          toggle={() => setShowBugComment(null)}
          isCve={false}
          userVersionData={userVersionData}
          projectVersionId={userVersionData.id}
          productName={selectedProject.productName}
          productId={selectedProject.productId}
          vendorId={selectedProject.vendorId}
          entityId={showBugComment}
          fetchUserVersionState={fetchUserVersionState}
          selectedVersion={selectedVersion}
        />
      )}
      {showCveComment && (
        <CommentModal
          isOpen={!!showCveComment}
          toggle={() => setShowCveComment(null)}
          isCve={true}
          userVersionData={userVersionData}
          projectVersionId={userVersionData.id}
          productName={selectedProject.productName}
          productId={selectedProject.productId}
          vendorId={selectedProject.vendorId}
          entityId={showCveComment}
          fetchUserVersionState={fetchUserVersionState}
          selectedVersion={selectedVersion}
        />
      )}

      {showDeleteProject && (
        <DeleteProjectModal
          isOpen={!!showDeleteProject}
          toggle={() => setShowDeleteProject(null)}
          projects={projects}
          project={showDeleteProject}
          setProjects={setProjects}
        />
      )}
    </Container>
  );
};

export default BugScrubbingTool;
